<template>
<b-container style="max-width: 1200px !important">

<b-row class="justify-content-center align-items-center">
    <h5 style="text-align:center" >QUANTEEC x Flowplayer 7</h5>
</b-row>


<b-tabs>
    <b-tab :title="$ml.get('plugininstallfromCDN')">

<b-row class="justify-content-center align-items-center marginaltopsm">
        <p style="margin-bottom:0px" v-html="$ml.get('pluginp5')">
            
        </p>
</b-row>
<b-row class="justify-content-center align-items-center">
  <ol class="center" style="margin: 10px">
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line1_flow)" />
          </li>
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp11')}}<br /> 
              <code>{{configLine}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(configLine)" />
          </li>
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp17')}}<br />
              <code>
                {{line3_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_flow)" />
          </li>
            <li style="margin-bottom:10px">
              {{$ml.get('pluginp19')}}<br />
              <code>
                {{line4_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line4_flow)" />
          </li>
          
  </ol>
</b-row>

<b-row>
<b-col cols="12">
    <!--
    <b-row class="justify-content-around align-items-center">
        <b-col cols="5" sm="4" md="3">
            <b-img fluid-grow :src="require('@/assets/logo_Q_Plugin.svg')">
                <h2>Plug-In</h2>
            </b-img>
        </b-col>
        <b-col cols="5" sm="4" md="3">
            <b-img fluid :src="require('@/assets/external_logo/flowplayer.png')">
                <h2>Flowplayer</h2>
            </b-img>
        </b-col> 
    </b-row>
    -->
    <b-row class="mt-2">
      <div class="col-xl-7 col-12" v-html="$ml.get('flow7_example')" ></div>

    <vue-markdown style="overflow: auto" class="col-xl-7 col-12">
```html
&lt;head>
    &lt;link href="flowplayer.css" rel="stylesheet" />

    &lt;script src="hls.min.js">&lt;/script>
    &lt;script src="flowplayer.min.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;div style="max-width:726px;max-height:408px;">
        &lt;div id="videoplayer" >&lt;/div>
    &lt;/div>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}",
            };

            // 3-Link QUANTEEC to flowplayer *before* the creation of the flowplayer instance
            var quanteecPlayer = new Quanteec(configQuanteec, flowplayer);

            var flow = flowplayer('#videoplayer',
            { 
                key: "$512206430871778",
                clip: {
                    sources: [
                    {
                        type : "application/x-mpegurl",
                        src: videoSource,
                    }
                    ]
                },
                autoplay: true
            })

            // 4-Declare your flowplayer instance to QUANTEEC
            quanteecPlayer.setFlowplayer(flow);
        });
    &lt;/script>
&lt;/body>   
    </vue-markdown>
    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
    </b-row>
</b-col>
</b-row>

    </b-tab>
    <b-tab :title="$ml.get('plugininstallfromNPM')">
    <b-row class="justify-content-center align-items-center marginaltopsm">
      <p style="margin-bottom:0px" v-html="$ml.get('pluginp5npm')">
                
      </p>
    </b-row>
    <b-row class="justify-content-center align-items-center">
      <ol class="center" style="margin: 10px">
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginloginnpm')}}<br />
                  <code>
                    {{$ml.get('loginnpmcode')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('loginnpmcode'))" />
              </li>             
              <li style="margin-bottom:10px">
                  {{$ml.get('plugininstallnpm')}}<br />
                  <code>
                    {{$ml.get('installnpmpackage')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('installnpmpackage'))" />
              </li>              
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginimportnpm')}}<br />
                  <code>
                    {{$ml.get('pluginimporthlsjsnpm')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('pluginimporthlsjsnpm'))" />
              </li>
            <li style="margin-bottom:10px">
            {{$ml.get('pluginp11')}}<br /> 
            <code>{{configLine}}
            </code>
            <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(configLine)" />
            </li>
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp17')}}<br />
              <code>
                {{line3_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_flow)" />
          </li>
            <li style="margin-bottom:10px">
              {{$ml.get('pluginp19')}}<br />
              <code>
                {{line4_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line4_flow)" />
          </li>
      </ol>
    </b-row>

    <b-row class="mt-2">
      <ConfigDoc class="col-12">
      </ConfigDoc>
    </b-row>
  </b-tab>
</b-tabs>



<CopiedModal ref="copied"/>

</b-container>
</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import CopiedModal from '@/components/modals/CopiedModal.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'Flowplayer',
  data: function() {
    return {
        line1_flow: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js"><'+'/script>',
        line3_flow: 'var quanteecPlayer = new Quanteec(configQuanteec, flowplayer);',
        line4_flow: 'quanteecPlayer.setFlowplayer(flow);',

    }
  },
  props: [
      "streamKey",
    "configLine"
  ],
  components: {
      VueMarkdown,
      ConfigDoc,
      CopiedModal
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>